const enTipologiaEvento = { FORMAZIONE: 'FORMAZIONE', DIDATTICO: 'DIDATTICO', GARA: 'GARA' };

const enCodiciTipoEventoAdmin = {
  CI_OUTDOOR: 'CI_OUTDOOR',
  CI_INDOOR: 'CI_INDOOR',
  CI_REGIONI: 'CI_REGIONI',
  IBO_OUTDOOR: 'IBO_OUTDOOR',
  IBO_INDOOR: 'IBO_INDOOR',
  CI_IBO_INDOOR: 'CI_IBO_INDOOR',
  CI_IBO_OUTDOOR: 'CI_IBO_OUTDOOR',

};

export {
  enTipologiaEvento,
  enCodiciTipoEventoAdmin,
};
